<template>
	<div>
		<van-nav-bar title="基础设置" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">
			
			<van-field v-model="bot_nick" name="bot_nick" :label="this.$Setting.web_bot_name + '名字:'" type="text" placeholder="比如:二哈" :rules="[{ required: true, message: '小助手名字' }]"
			 maxlength="5" show-word-limit />
			 
			 <div style="margin-left: 0.2rem;">
			 	<p style="font-size: 10px;font-weight: bold;color: #1989fa;">设置后可以通过名字召唤{{this.$Setting.web_bot_name}}出来</p>
			 	<p style="font-size: 10px;font-weight: bold;color: #1989fa;">如果设置为“二哈” 则可以使用 “二哈来一首成都”</p>
			 </div>
			
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		Tag
	} from 'vant';

	Vue.use(Tag);
	export default {
		data() {
			return {
				group_id: 0,
				black_checked: false,
				op: 'set',

				bot_nick: ''

			}
		},
		mounted() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.bot_nick = res.data.bot_nick
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
						return
					}
					this.$toast.success('已保存')
				})
			},
		}
	}
</script>

<style>
</style>
